export * from "./eula-text";
